// extracted by mini-css-extract-plugin
module.exports = {"selector":"ComponentSelector_selector__1be7G","select":"ComponentSelector_select__375AU"};